import React, { useState } from "react";

//Services
import api from "../services/api";

//Sweet alert
import Swal from "sweetalert2";

//Components
import {
  Input,
  Button
} from "../components";

//React router
import {
  Link
} from "react-router-dom";

import {
  useForm
} from "react-hook-form";

import {
  yupResolver
} from "@hookform/resolvers/yup";

import * as yup from "yup";
import useLocalStorage from "use-local-storage";

const schema = yup.object({
  email: yup.string().email("Preencha um e-mail válido.").required("O campo e-mail precisa ser preenchido.")
}).required();

const Password = (props) => {
  const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(schema) });

  const [loading, setLoading] = useState(false);

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer)
      toast.addEventListener("mouseleave", Swal.resumeTimer)
    }
  });

  const openAlert = (icon, title, text) => {
    Toast.fire({
      icon,
      title,
      text
    });
  };

  const onSubmit = async data => {
    setLoading(true);

    try {
      const response = await api.post("/password/reset", data);

      console.log(response.data);

      if (response.data.error) {
        let icon = "error";
        let title = "Ocorreu um erro";
        let text = response.data.message;

        openAlert(icon, title, text);
      } else {
        let icon = "success";
        let title = "Sucesso";
        let text = response.data.message;

        openAlert(icon, title, text);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const [theme] = useLocalStorage("theme");

  return (
    <div className="container-signin" data-theme={theme}>
      <Link className="back-link" to="/">
        ← redefinir senha
      </Link>

      <p className="p-info">
        insira o e-mail associado à sua conta
        e enviaremos um e-mail com instruções
        para redefinir sua senha
      </p>

      <div className="white-box mt-1">

        <form onSubmit={handleSubmit(onSubmit)}>

          <Input
            label="Endereço de e-mail"
            type="text"
            placeholder="voce@usadaomaquinas.com.br"
            name="email"
            register={register}
            error={errors.email} />

          <div className="mt-20"></div>

          <Button
            title="Enviar instruções"
            color="red"
            width="full"
            loading={loading} />

        </form>
      </div>



    </div>
  );
}

export default Password;